import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.asset.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.asset.fields.name'),
  },
  {
    name: 'type',
    label: i18n('entities.asset.fields.type'),
  },
  {
    name: 'group',
    label: i18n('entities.asset.fields.group'),
    render: exporterRenders.boolean(),
  },
  {
    name: 'groupAssets',
    label: i18n('entities.asset.fields.groupAssets'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'keywords',
    label: i18n('entities.asset.fields.keywords'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'state',
    label: i18n('entities.asset.fields.state'),
  },
  {
    name: 'classification',
    label: i18n('entities.asset.fields.classification'),
  },
  {
    name: 'locationGoogle',
    label: i18n('entities.asset.fields.locationGoogle'),
  },
  {
    name: 'location',
    label: i18n('entities.asset.fields.location'),
    render: exporterRenders.relationToOne(),
  },
  {
    name: 'responsible',
    label: i18n('entities.asset.fields.responsible'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'internalLicenseExpirationDate',
    label: i18n(
      'entities.asset.fields.internalLicenseExpirationDate',
    ),
    render: exporterRenders.datetime(),
  },
  {
    name: 'lastMaintenanceDate',
    label: i18n(
      'entities.asset.fields.lastMaintenanceDate',
    ),
    render: exporterRenders.datetime(),
  },
  {
    name: 'nextMaintenanceDate',
    label: i18n(
      'entities.asset.fields.nextMaintenanceDate',
    ),
    render: exporterRenders.datetime(),
  },
  {
    name: 'examDueDate',
    label: i18n('entities.asset.fields.examDueDate'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'enableNotifications',
    label: i18n(
      'entities.asset.fields.enableNotifications',
    ),
    render: exporterRenders.boolean(),
  },
  {
    name: 'icon',
    label: i18n('entities.asset.fields.icon'),
    render: exporterRenders.filesOrImages(),
  },
  {
    name: 'status',
    label: i18n('entities.asset.fields.status'),
  },
  {
    name: 'createdAt',
    label: i18n('entities.asset.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.asset.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
